// extracted by mini-css-extract-plugin
export var audioPlayer = "_qt-0";